import { put, call, takeEvery } from 'redux-saga/effects';

import * as types from './constants';
import * as actions from './actions';
import { handleErrors, fetch } from '../../api';
import api from '../../api/endpoints';

function* getReferralLink({ payload: { signal, handledErrors }  }) {
  try {
    const { data } = yield call(fetch, { api: api.refer.latest, signal });

    yield put(actions.getReferralLinkDone(data.result));
  } catch (error) {
    yield handleErrors({
      error,
      putErrorData: actions.getReferralLinkFailed,
      handledErrors,
      endpoint: api.refer.latest.url
    });
  }
}

function* createReferralLink({ payload: { handledErrors }  }) {
  try {
    const { data } = yield call(fetch, { api: api.refer.create });

    yield put(actions.createReferralLinkDone(data.result));
  } catch (error) {
    yield handleErrors({
      error,
      putErrorData: actions.createReferralLinkFailed,
      handledErrors,
      endpoint: api.refer.create.url
    });
  }
}

export const getReferralLinkSaga = takeEvery(types.GET_REFERRALS_LINK_REQUEST, getReferralLink);
export const createReferralLinkSaga = takeEvery(types.CREATE_REFERRALS_LINK_REQUEST, createReferralLink);